import { Grid, Paper } from '@mui/material'
import { DoorDirection } from '@planning/app/api'
import { CustomsSubForm } from '@planning/components/organisms/CustomsSubForm'
import { DoorDirectionFormControl } from '@planning/pages/Order/V2/molecules/DoorDirectionField'
import { DirectionalCargoDetailsType } from '@planning/pages/Order/V2/organisms/DirectionalCargoDetailsSubForm'
import { OrderSealsSubForm } from '@planning/pages/Order/V2/organisms/OrderSealsSubForm'
import { FormField, IFormStore } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'

export const OrderAditionalCargoInformationCard = observer(
  ({
    cargoDetailsFormStore,
    initialValues,
    isSmallView,
    hasCustoms,
    hasDoorDirection,
  }: {
    cargoDetailsFormStore: IFormStore<DirectionalCargoDetailsType>
    initialValues?: Partial<DirectionalCargoDetailsType>
    isSmallView?: boolean
    hasCustoms?: boolean
    hasDoorDirection?: boolean
  }) => {
    return (
      <Paper variant='outlined' sx={{ p: '1rem' }}>
        <Grid container spacing={2}>
          <Grid size={hasCustoms || hasDoorDirection ? 6 : 12}>
            <OrderSealsSubForm
              formStore={cargoDetailsFormStore}
              name='seals'
              initialValues={initialValues?.seals}
              isSmallView={isSmallView}
            />
          </Grid>

          {hasCustoms && (
            <Grid size={6}>
              <Paper variant='outlined' sx={{ p: '1rem' }}>
                <CustomsSubForm
                  name={'customs'}
                  formStore={cargoDetailsFormStore}
                  allowDelete={true}
                  showHeader={true}
                  initialValue={initialValues?.customs}
                />
              </Paper>
            </Grid>
          )}
          {hasDoorDirection && (
            <Grid size={hasCustoms ? 12 : 6}>
              <FormField
                formStore={cargoDetailsFormStore}
                name={'doorDirection'}
                initialValue={initialValues?.doorDirection ?? DoorDirection.Anyway}
              >
                {field => (
                  <DoorDirectionFormControl value={field.value} onChange={field.onChange} />
                )}
              </FormField>
            </Grid>
          )}
        </Grid>
      </Paper>
    )
  },
)
